export default "__VITE_ASSET__$SWheFZn__"